import { render, staticRenderFns } from "./confirm-email.vue?vue&type=template&id=bdde1720&scoped=true&"
import script from "./confirm-email.vue?vue&type=script&lang=js&"
export * from "./confirm-email.vue?vue&type=script&lang=js&"
import style0 from "./confirm-email.vue?vue&type=style&index=0&id=bdde1720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdde1720",
  null
  
)

export default component.exports